import { Roles } from "@/helpers/enums/Roles";
import axiosAgsc from "@/store/axiosAgsc";
const resource = "/Company";

export default {
  get: (payload: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetCompanyList`, {params:payload});
  },
  getByGuid: (companyGuid: any = {}): any => {
    if(Object.keys(companyGuid).length === 0) {
      return false;
    }
    return axiosAgsc.get(`${resource}/GetCompanyById`, {
      params: { 
        companyGuid: companyGuid 
      },
    });
  },
  getCompanyTree: (): any => {
    return axiosAgsc.get(`${resource}/GetCompanyTree`, {});
  },
  getScopeTree: (): any => {
    return axiosAgsc.get(`${resource}/GetScopeTree`, {});
  },
};
